<script>
import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  props: {
    object: {
      type: Object,
      required: true
    }
  },
  computed: {
    highlights() {
      return this.getTranslatedContent('highlights', this.object.content).length ?
      this.getTranslatedContent('highlights', this.object.content) : this.object.content.en.highlights
    },
  },
}
</script>

<template>
  <div class="tab-content">
    <h5>{{ getTranslatedContent('TABS_Highlights') }}</h5>
    <ul class="highlights-list">
      <li
        v-for="(highlight, index) in highlights"
        :key="index"
        class="highlight-item"
      >
        {{ highlight }}
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

h5 {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  color: #FFFFFF;
  margin-bottom: 15px;
  margin-left: 31px;
}

.tab-content {
  margin-top: 35px;

  .highlights-list {
    margin-left: 48px;
    width: 284px;

    & li {
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #FFFFFF;
      margin-bottom: 9px;
      list-style-image: url("../../assets/icons/checkmark.svg");
      list-style-position: outside;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media only screen and (max-width: $screen-width-xs) {
  .tab-content {
    .highlights-list {
      margin-right: 20px;
      width: auto;

      & li {
        line-height: 19px;
        margin-bottom: 6px;
        padding-left: 10px;
      }
    }
  }
}
</style>
